<template>
  <form class="px-2 pt-2"
        name="formAddMedico">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="label"
                 for="uf">Estado</label>
          <select id="uf"
                  v-model="formData.uf"
                  class="custom-select custom-select-sm"
                  name="uf"
                  @change="ufChanged">
            <option selected
                    :value="null">
              Selecione
            </option>
            <option v-for="state in selectsOptions.states"
                    :key="state.id"
                    :value="state.uf">
              {{ state.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label class="label"
                 for="crm">CRM do Médico</label>
          <input id="crm"
                 v-model="formData.crm"
                 v-validate="{ required: !!formData.nome }"
                 :class="{ 'is-invalid': errors.has('crm') }"
                 class="form-control form-control-sm"
                 name="crm"
                 placeholder="0000"
                 type="text"
                 @change="validateInputs('crm'), loadMedico()">
          <small v-if="errors.has('crm')"
                 class="invalid-feedback">{{ errors.first('crm') }}</small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-8 col-md-6">
        <div class="form-group">
          <label class="label"
                 for="nome_medico">Nome do Médico</label>
          <input id="nome_medico"
                 v-model="formData.nome"
                 v-uppercase
                 v-validate="{ required: !!formData.crm }"
                 class="form-control form-control-sm"
                 :class="{ 'is-invalid': errors.has('nome_medico') }"
                 name="nome_medico"
                 placeholder="João da Silva Souza Santos Pereira"
                 type="text"
                 @change="validateInputs('nome_medico')">
          <small v-if="errors.has('nome_medico')"
                 class="invalid-feedback">{{ errors.first('nome_medico') }}</small>
        </div>
      </div>

      <div class="col-sm-4 col-md-6">
        <div class="form-group">
          <label class="label d-block"
                 for="nomeMedico">Médico Legista</label>
          <span class="custom-control custom-radio custom-control-inline">
            <input :id="`legista-sim-${ _uid }`"
                   v-model="formData.legista"
                   :value="1"
                   :name="`legista-sim-${ _uid }`"
                   type="radio"
                   class="custom-control-input"
                   @change="setLegista"
                   @keyup.enter="setLegista">
            <label class="custom-control-label"
                   :for="`legista-sim-${ _uid }`">Sim</label>
          </span>
          <span class="custom-control custom-radio custom-control-inline">
            <input :id="`legista-nao-${ _uid }`"
                   v-model="formData.legista"
                   :name="`legista-nao-${ _uid }`"
                   :value="0"
                   type="radio"
                   class="custom-control-input"
                   @change="setLegista"
                   @keyup.enter="setLegista">
            <label class="custom-control-label"
                   :for="`legista-nao-${ _uid }`">Não</label>
          </span>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import BrazilianStates from "@/constants/brazilianStates"

  /* services */
  import BuscaService from "@/services/BuscaService"

  export default {
    name: 'FormAddMedico',
    props: {
      medico: {
        type: Object,
        default: () => ({})
      }
    },
    inject: ['$validator'],
    data () {
      return {
        selectsOptions: {
          states: [...BrazilianStates]
        },
        formData: {
          crm: null,
          nome: null,
          uf: null,
          legista: 0
        }
      }
    },
    watch: {
      medico () {
        this.formData = {...this.medico}
      }
    },
    mounted () {
      if (Object.values(this.medico).length) {
        this.formData = {...this.medico}
      }
    },
    methods: {
      async loadMedico () {
        let crm = this.formData.crm
        let uf = this.formData.uf

        try {
          if (crm && uf) {
            const medico = await BuscaService.searchMedico(crm, uf)
            if (!!medico.nome) {
              this.formData.nome = medico.nome
            }
          }
        } catch (e) {
          console.error(e)
        } finally {
          this.changed()
        }
      },
      ufChanged () {
        this.loadMedico()
        this.changed()
      },
      changed () {
        this.$emit('changed', this.formData)
      },
      validateInputs (name) {
        this.$validator.validate(name)
        this.changed()
      },
      setLegista (value) {
        this.formData.legista = parseInt(value.target.value, 10)
        this.changed()
      }
    }
  }
</script>

<style scoped>

</style>
